(function (app, ng) {

    app.directive("decimal",
        [
            function () {
                return {
                    require: "ngModel",
                    scope: {

                    },
                    restrict: "A",
                    link: function (scope, element, attrs, ngModelCtrl) {
                        if (!ngModelCtrl) {
                            return;
                        }

                        ngModelCtrl.$parsers.push(function (val) {
                            if (ng.isUndefined(val)) {
                                val = "";
                            }

                            var clean = val.replace(/[^0-9\.]/g, "");
                            var decimalCheck = clean.split(".");

                            if (!ng.isUndefined(decimalCheck[1])) {
                                decimalCheck[1] = decimalCheck[1].slice(0, 2);
                                clean = decimalCheck[0] + "." + decimalCheck[1];
                            }

                            if (val !== clean) {
                                ngModelCtrl.$setViewValue(clean);
                                ngModelCtrl.$render();
                            }

                            return clean;
                        });

                        element.bind("keypress", function (event) {
                            if (event.keyCode === 32) {
                                event.preventDefault();
                            }
                        });
                    }

                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line)